// extracted by mini-css-extract-plugin
export var excerpt = "TopMenuExtended-module--excerpt--d23af";
export var menuItens = "TopMenuExtended-module--menuItens--42072";
export var menuLink = "TopMenuExtended-module--menuLink--4b3d7";
export var menuLinkActive = "TopMenuExtended-module--menuLinkActive--0d478";
export var menuSelector = "TopMenuExtended-module--menuSelector--73131";
export var navigator = "TopMenuExtended-module--navigator--8995b";
export var navigatorActive = "TopMenuExtended-module--navigatorActive--6bb05";
export var submenuLink = "TopMenuExtended-module--submenuLink--3c8d6";
export var wrapper = "TopMenuExtended-module--wrapper--44d8a";